import { Chip, Grid, Stack } from "@mui/material";
import SoftBox from "components/SoftBox";
import React, { useState } from "react";
import GroupModal from "../Modals/GroupModal";
import DataTable from "../DataTable";
import dataTableData from "../data/group";
import { useAgencyInfo } from "context/agency";
import { useAppServices } from "hook/services";
import SoftTypography from "components/SoftTypography";
import { Add, TipsAndUpdates } from "@mui/icons-material";
import SoftButton from "components/SoftButton";
import Editor from "../editor";
import SoftInput from "components/SoftInput";
function DefaultEmail() {
  const [processing, setProcessing] = useState(false);

  const [agency, handleRefresh, Update] = useAgencyInfo();
  const AppService = useAppServices();
  const [defaultEmailTemplate, setDefaultEmailTemplate] = useState(agency?.defaultEmail?.defaultEmailTemplate);
  const [subject, setSubject] = useState(agency?.defaultEmail?.subject);

  const handleSubmit = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    setProcessing(true);
    const payload = {
      _id: agency._id,
      defaultEmail: {
        subject: subject,
        defaultEmailTemplate: defaultEmailTemplate
      },
    };
    const { response } = await AppService.agency.update({
      payload,
      toaster: true,
    });
    if (response) {
      handleRefresh();
      setProcessing(false);
    }
  };

  const handleCustomInputs = (customInput) => {
    setDefaultEmailTemplate(`${defaultEmailTemplate} ${customInput}`)
  }

  const customInputOptions = ['{{ticket.subject}}', '{{ticket.number}}', '{{ticket.description}}', '{{loom.video}}', '{{agency.name}}']

  return (
    <SoftBox>
      <Grid container rowSpacing={3}>
        <Grid item xs={12} mt={3}>
          <Stack direction="row" spacing={1}>
            {customInputOptions?.map((item, index) => (
              <Chip
                key={index}
                label={item}
                icon={<Add />}
                onClick={() => handleCustomInputs(item)}
                sx={{ cursor: "pointer" }}
                variant="outlined"
              />
            ))}
          </Stack>
        </Grid>
        <Grid item xs={12} mt={0} p={0}>
          <SoftBox pt={0}>
            <SoftBox>
              <SoftTypography variant="button" sx={{ fontSize: "14px", fontWeight: "500", marginBottom: '10px' }} >
                Subject
              </SoftTypography>
              <SoftInput value={subject} label="Subject" placeholder="Subject" name="subject" onChange={(e) => setSubject(e.target.value)} fullWidth />
            </SoftBox>
            <SoftBox sx={{ marginTop: '20px' }}>
              <Editor
                handleChange={(data) => {
                  setDefaultEmailTemplate(data);
                }}
                data={defaultEmailTemplate}
              />
            </SoftBox>
            <SoftButton
              variant="outlined"
              color="dark"
              type="button"
              onClick={(e) => handleSubmit(e)}
              loading={processing}
              disabled={processing}
              size="small"
              style={{ marginTop: "12px" }}
            >
              Save
            </SoftButton>
          </SoftBox>
        </Grid>
      </Grid>
    </SoftBox>
  );
}

export default DefaultEmail;
